<template>
  <!-- eslint-disable-next-line vue/multi-word-component-names -->
  <div class="login-container dark-theme">
    <!-- 背景装饰 -->
    <div class="background-decoration">
      <div class="bg-circle bg-circle-1"></div>
      <div class="bg-circle bg-circle-2"></div>
      <div class="bg-circle bg-circle-3"></div>
    </div>

    <!-- 主内容区 -->
    <div class="login-main">
      <!-- 顶部品牌信息 -->
      <div class="brand-header">
        <div class="brand-logo" @click="handleLogoClick" style="cursor: pointer;">
          <img :src="require('../assets/images/ipipbright.png')" alt="IpipBright logo" style="height: 60px; width: auto; filter: brightness(1.2);">
        </div>
        <h1 class="brand-slogan">{{ i18n[currentLanguage].brandSlogan }}</h1>
      </div>

      <!-- 左侧特性 + 右侧表单布局 -->
      <div class="form-features-container">
        <!-- 左侧特性展示（四个特性项） -->
        <div class="features-sidebar left-features">
          <div class="feature-item">
            <a-icon type="safety-certificate" class="feature-icon" />
            <div class="feature-content">
              <h3 class="feature-title">{{ i18n[currentLanguage].featureSecurity }}</h3>
              <p class="feature-desc">{{ i18n[currentLanguage].featureSecurityDesc }}</p>
            </div>
          </div>
          <div class="feature-item">
            <a-icon type="swap" class="feature-icon" />
            <div class="feature-content">
              <h3 class="feature-title">{{ i18n[currentLanguage].featureRotation }}</h3>
              <p class="feature-desc">{{ i18n[currentLanguage].featureRotationDesc }}</p>
            </div>
          </div>
          <div class="feature-item">
            <a-icon type="cluster" class="feature-icon" />
            <div class="feature-content">
              <h3 class="feature-title">{{ i18n[currentLanguage].featureRegions }}</h3>
              <p class="feature-desc">{{ i18n[currentLanguage].featureRegionsDesc }}</p>
            </div>
          </div>
          <div class="feature-item">
            <a-icon type="line-chart" class="feature-icon" />
            <div class="feature-content">
              <h3 class="feature-title">{{ i18n[currentLanguage].featurePerformance }}</h3>
              <p class="feature-desc">{{ i18n[currentLanguage].featurePerformanceDesc }}</p>
            </div>
          </div>
        </div>

        <!-- 右侧登录卡片 -->
        <div class="login-card">
          <!-- 语言切换 -->
          <div class="language-switcher">
            <span 
              class="lang-tag"
              @click="changeLanguage(currentLanguage === 'zh' ? 'en' : 'zh')"
            >{{ currentLanguage.toUpperCase() }}</span>
          </div>
          
          <div class="login-header">
            <h2 class="login-title">{{ i18n[currentLanguage].welcomeBack }}</h2>
            <p class="login-subtitle">{{ i18n[currentLanguage].pleaseLogin }}</p>
          </div>
          
          <a-form
            ref="form"
            :form="form"
            :rules="formRules"
            class="login-form"
          >
            <a-form-item label="" prop="username">
              <a-input
                v-decorator="['username', { initialValue: '' }]"
                size="large"
                :placeholder="i18n[currentLanguage].username"
                class="custom-input"
              >
                <a-icon slot="prefix" type="user" class="custom-icon" />
              </a-input>
            </a-form-item>

            <a-form-item label="" prop="password">
              <a-input-password
                v-decorator="['password', { initialValue: '' }]"
                size="large"
                :placeholder="i18n[currentLanguage].password"
                class="custom-input"
              >
                <a-icon slot="prefix" type="lock" class="custom-icon" />
              </a-input-password>
            </a-form-item>

            <a-form-item label="" prop="goolecode">
              <a-input
                v-decorator="['goolecode', { initialValue: '' }]"
                size="large"
                placeholder="谷歌验证码（选填）"
                class="custom-input"
              >
                <a-icon slot="prefix" type="security-scan" class="custom-icon" />
              </a-input>
            </a-form-item>

            <!-- 隐藏字段，默认值 -->
            <a-form-item label="" prop="userType" style="display: none;">
              <a-input
                v-decorator="['userType', { initialValue: 'ipipbright' }]"
              >
              </a-input>
            </a-form-item>

            <a-form-item label="" prop="phone" style="display: none;">
              <a-input
                v-decorator="['phone', { initialValue: '' }]"
              >
              </a-input>
            </a-form-item>

            <div class="login-options">
              <a-checkbox v-decorator="['checked', { initialValue: false, valuePropName: 'checked' }]" class="remember-me">
                {{ i18n[currentLanguage].rememberMe }}
              </a-checkbox>
              <!-- <a href="#" class="forgot-password">{{ i18n[currentLanguage].forgotPassword }}</a> -->
            </div>

            <a-form-item>
              <a-button
                type="primary"
                size="large"
                block
                @click="handleSubmit"
                class="login-button"
              >
                <a-icon type="login" class="button-icon" />
                {{ i18n[currentLanguage].login }}
              </a-button>
            </a-form-item>

            <div class="register-section">
              <span class="register-text">{{ i18n[currentLanguage].noAccount }}</span>
              <a href="/register" class="register-link">{{ i18n[currentLanguage].registerNow }}</a>
            </div>
          </a-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginView',
  data() {
    return {
      form: this.$form.createForm(this),
      codeUrl: '',
      // 语言切换相关数据
      currentLanguage: 'en', // 默认中文
      languages: [
        { value: 'zh', label: '简体中文' },
        { value: 'en', label: 'English' }
      ],
      // 国际化文本
      i18n: {
        zh: {
          welcomeBack: '欢迎回来',
          pleaseLogin: '请使用您的账号登录',
          username: '账号',
          password: '密码',
          verificationCode: '验证码',
          rememberMe: '记住我',
          forgotPassword: '忘记密码？',
          login: '登录',
          noAccount: '还没有账号？',
          registerNow: '立即注册',
          loginSuccess: '登录成功',
          loginFailed: '登录失败',
          verificationCodeRequired: '验证码不能为空',
          requestFailed: '登录请求失败',
          getCodeFailed: '获取验证码失败',
          // 左侧品牌区域国际化 - 动态IP代理网站
          brandSlogan: '动态IP代理，全球网络加速',
          featureSecurity: '安全可靠',
          featureSecurityDesc: '企业级加密技术，保障数据安全',
          featureRotation: '智能轮换',
          featureRotationDesc: '自动IP轮换，防止被封锁',
          featureRegions: '全球覆盖',
          featureRegionsDesc: '覆盖200+国家和地区',
          featurePerformance: '高速稳定',
          featurePerformanceDesc: '99.9% uptime，低延迟连接',
          brandTagline: '选择ipipbright，畅享全球网络资源',
          statUsers: '活跃用户',
          statUptime: '服务可用性',
          statNodes: '优质IP节点'
        },
        en: {
          welcomeBack: 'Welcome Back',
          pleaseLogin: 'Please login with your account',
          username: 'Username',
          password: 'Password',
          verificationCode: 'Verification Code',
          rememberMe: 'Remember Me',
          forgotPassword: 'Forgot Password?',
          login: 'Login',
          noAccount: 'Don\'t have an account?',
          registerNow: 'Register Now',
          loginSuccess: 'Login Success',
          loginFailed: 'Login Failed',
          verificationCodeRequired: 'Verification code is required',
          requestFailed: 'Login request failed',
          getCodeFailed: 'Failed to get verification code',
          // 左侧品牌区域国际化 - Dynamic IP Proxy Website
          brandSlogan: 'Dynamic IP Proxy, Global Network Acceleration',
          featureSecurity: 'Secure & Reliable',
          featureSecurityDesc: 'Enterprise-level encryption technology',
          featureRotation: 'Smart Rotation',
          featureRotationDesc: 'Automatic IP rotation to prevent blocking',
          featureRegions: 'Global Coverage',
          featureRegionsDesc: 'Covering 200+ countries and regions',
          featurePerformance: 'High Speed & Stable',
          featurePerformanceDesc: '99.9% uptime, low latency connection',
          brandTagline: 'Choose ipipbright, Enjoy Global Network Resources',
          statUsers: 'Active Users',
          statUptime: 'Service Availability',
          statNodes: 'Premium IP Nodes'
        }
      },
      formRules: {
        username: [{ required: true, message: '账号必填', trigger: 'blur' }],
        password: [{ required: true, message: '密码必填', trigger: 'blur' }],
        code: [{ required: true, message: '验证码必填', trigger: 'blur' }]
      }
    };
  },
  mounted() {
    // this.getCodeNew();
  },
  methods: {
    // 处理logo点击事件
    handleLogoClick() {
      this.$router.push('/');
    },
    // 切换语言
    changeLanguage(language) {
      this.currentLanguage = language;
      // 更新表单规则的验证消息
      this.updateFormRules();
    },
    // 更新表单规则的验证消息
    updateFormRules() {
      this.formRules = {
        username: [{ required: true, message: this.i18n[this.currentLanguage].username + '必填', trigger: 'blur' }],
        password: [{ required: true, message: this.i18n[this.currentLanguage].password + '必填', trigger: 'blur' }],
        // code: [{ required: true, message: this.i18n[this.currentLanguage].verificationCode + '必填', trigger: 'blur' }]
      };
    },
    // 获取验证码
    getCodeNew() {
      // 假设request是全局可用的，或者需要通过import引入
      this.$request.get('/auth/captcha', { responseType: 'arraybuffer' })
        .then(res => {
          if (res.status === 200) {
            const base64 = btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
            this.codeUrl = `data:image/png;base64,${base64}`;
            // 假设后端返回的uuid在响应头中
            // this.form.setFieldsValue({ uuid: res.headers.uuid });
          }
        })
        .catch(err => {
          console.error('获取验证码失败:', err);
          this.$message.error(this.i18n[this.currentLanguage].getCodeFailed);
        });
    },
    // 表单提交
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          // 假设request是全局可用的，或者需要通过import引入
          this.$request.post('/auth/login', values)
            .then(res => {
              if (res.data.code === 200) {
                // 登录成功处理
                localStorage.setItem('Token', res.data.data.token);
                localStorage.setItem('Authorization', res.data.data.token);
                localStorage.setItem('userName', values.username);
                localStorage.setItem('userId', res.data.data.uid);
                localStorage.setItem('subNumber', res.data.data.userInfo.subNumber);
                this.$message.success(this.i18n[this.currentLanguage].loginSuccess);
                this.$router.push('/dashboard/base');
              } else {
                // 登录失败处理
                if (res.data.msg === '验证码不能为空') {
                  this.$message.warning(this.i18n[this.currentLanguage].verificationCodeRequired);
                } else {
                  this.$message.warning(this.i18n[this.currentLanguage].loginFailed);
                }
                this.getCodeNew();
              }
            })
            .catch(err => {
              console.error('登录请求失败:', err);
              this.$message.error(this.i18n[this.currentLanguage].requestFailed);
            });
        }
      });
    }
  }
};
</script>

<style scoped>
/* 基础样式重置 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body, html {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background: #0a0a0a;
  color: #ffffff;
  min-height: 100vh;
  overflow-x: hidden;
}

/* 登录容器 - 黑暗主题 */
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%);
  position: relative;
  overflow: hidden;
}

/* 背景装饰 */
.background-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
}

.bg-circle {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.2;
}

.bg-circle-1 {
  width: 600px;
  height: 600px;
  background: linear-gradient(135deg, #1581c6 0%, #64b5f6 100%);
  top: -100px;
  left: -100px;
  animation: float 20s ease-in-out infinite;
}

.bg-circle-2 {
  width: 400px;
  height: 400px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
  bottom: -150px;
  right: -150px;
  animation: float 15s ease-in-out infinite reverse;
}

.bg-circle-3 {
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, #4ecdc4 0%, #45b7d1 100%);
  top: 50%;
  right: 10%;
  animation: float 18s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33% { transform: translate(30px, -30px) scale(1.1); }
  66% { transform: translate(-20px, 20px) scale(0.9); }
}

/* 主内容区域 */
.login-main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  min-height: 100vh;
  padding: 40px 20px;
  position: relative;
  z-index: 1;
  max-width: 1400px;
  margin: 0 auto;
}

/* 顶部品牌信息 */
.brand-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 20px;
  opacity: 0.9;
  width: 100%;
  max-width: 1000px;
}

.brand-logo {
  margin-bottom: 20px;
  transition: transform 0.3s ease;
}

.brand-logo:hover {
  transform: scale(1.05);
}

.brand-slogan {
  font-size: 36px;
  font-weight: 700;
  margin: 0;
  background: linear-gradient(135deg, #64b5f6 0%, #1581c6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.2;
  max-width: 800px;
}

/* 左侧特性 + 右侧表单布局容器 */
.form-features-container {
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 30px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

/* 特性侧边栏 */
.features-sidebar {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  flex: 1;
  margin-top: 20px;
  min-width: 300px;
}

/* 右侧登录卡片 */
.login-card {
  width: 100%;
  flex: 1;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 50px 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(15px);
  animation: fadeInUp 0.8s ease-out;
  position: relative;
  z-index: 2;
  min-width: 300px;
}

/* 特性项 */
.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 16px;
  padding: 28px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  min-height: 180px;
}

.feature-item:hover {
  background: rgba(255, 255, 255, 0.08);
  transform: translateY(-6px) scale(1.02);
  box-shadow: 0 12px 32px rgba(100, 181, 246, 0.2);
  border-color: rgba(100, 181, 246, 0.4);
}

.feature-icon {
  font-size: 32px;
  color: #64b5f6;
  background: linear-gradient(135deg, rgba(100, 181, 246, 0.2), rgba(21, 129, 198, 0.2));
  padding: 16px;
  border-radius: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(100, 181, 246, 0.3);
}

.feature-item:hover .feature-icon {
  transform: scale(1.1) rotate(5deg);
  background: linear-gradient(135deg, rgba(100, 181, 246, 0.3), rgba(21, 129, 198, 0.3));
  box-shadow: 0 10px 28px rgba(100, 181, 246, 0.4);
}

/* 特性内容 */
.feature-content {
  text-align: center;
}

.feature-title {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 8px 0;
  line-height: 1.3;
}

.feature-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  line-height: 1.5;
}

/* 旧样式兼容 */
.feature-text {
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 语言切换 */
.language-switcher {
  position: absolute;
  top: 20px;
  right: 20px;
}

.lang-tag {
  display: inline-block;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 25px;
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.3s ease;
  letter-spacing: 1px;
}

.lang-tag:hover {
  background: linear-gradient(135deg, #64b5f6 0%, #1581c6 100%);
  color: #ffffff;
  border-color: transparent;
  box-shadow: 0 4px 16px rgba(100, 181, 246, 0.4);
}

/* 登录头部 */
.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-title {
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 12px;
}

.login-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

/* 表单样式 */
.login-form {
  width: 100%;
}

/* 重置所有输入框相关样式 */
:deep(.ant-input),
:deep(.ant-input-password .ant-input),
:deep(.ant-input-wrapper .ant-input),
:deep(.ant-input-password .ant-input-wrapper .ant-input) {
  width: 100% !important;
  height: 56px !important;
  padding: 16px 16px 16px 48px !important;
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 12px !important;
  color: #ffffff !important;
  font-size: 16px !important;
  transition: all 0.3s ease !important;
  outline: none !important;
  text-indent: 0 !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

/* 统一 placeholder 样式 */
:deep(.ant-input::placeholder),
:deep(.ant-input-password .ant-input::placeholder) {
  color: rgba(255, 255, 255, 0.4) !important;
  text-indent: 0 !important;
  padding-left: 0 !important;
  margin-left: 0 !important;
}

/* 统一输入框悬停效果 */
:deep(.ant-input:hover),
:deep(.ant-input-password:hover .ant-input) {
  border-color: rgba(255, 255, 255, 0.2) !important;
  background: rgba(255, 255, 255, 0.08) !important;
}

/* 统一输入框聚焦效果 */
:deep(.ant-input:focus),
:deep(.ant-input-password:focus-within .ant-input) {
  border-color: #64b5f6 !important;
  background: rgba(255, 255, 255, 0.08) !important;
  box-shadow: 0 0 0 3px rgba(100, 181, 246, 0.1) !important;
}

/* 完全重置前缀样式，确保不影响 placeholder 位置 */
:deep(.ant-input-prefix),
:deep(.ant-input-password .ant-input-prefix) {
  position: absolute !important;
  left: 16px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  margin: 0 !important;
  padding: 0 !important;
  width: auto !important;
  height: auto !important;
  min-width: 0 !important;
  color: rgba(255, 255, 255, 0.5) !important;
  z-index: 10 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* 统一前缀图标样式 */
:deep(.ant-input-prefix .anticon),
:deep(.ant-input-password .ant-input-prefix .anticon) {
  font-size: 18px !important;
  color: rgba(255, 255, 255, 0.5) !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* 确保后缀样式不会影响输入框 */
:deep(.ant-input-suffix),
:deep(.ant-input-password .ant-input-suffix) {
  position: absolute !important;
  right: 16px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  margin: 0 !important;
  padding: 0 !important;
  width: auto !important;
  height: auto !important;
  min-width: 0 !important;
  z-index: 10 !important;
}

/* 统一后缀图标样式 */
:deep(.ant-input-suffix .anticon),
:deep(.ant-input-password .ant-input-suffix .anticon) {
  color: rgba(255, 255, 255, 0.5) !important;
  margin: 0 !important;
  padding: 0 !important;
  font-size: 16px !important;
}

/* 确保 input-group 样式不会影响 */
.input-group {
  display: block !important;
  position: relative !important;
  margin-bottom: 24px !important;
  width: 100% !important;
}

/* 确保自定义图标样式不会影响 */
.custom-icon {
  font-size: 18px !important;
  color: rgba(255, 255, 255, 0.5) !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* 确保输入框容器不会影响样式 */
:deep(.ant-input-wrapper),
:deep(.ant-input-password .ant-input-wrapper) {
  width: 100% !important;
  position: relative !important;
}

/* 调整表单项间距 */
:deep(.ant-form-item) {
  margin-bottom: 24px !important;
}

/* 登录选项 */
.login-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  font-size: 14px;
}

.remember-me {
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: color 0.3s ease;
}

.remember-me:hover {
  color: #64b5f6;
}

.forgot-password {
  color: #64b5f6;
  text-decoration: none;
  transition: all 0.3s ease;
}

.forgot-password:hover {
  color: #1581c6;
  text-decoration: underline;
}

/* 登录按钮 */
.login-button {
  width: 100%;
  height: 56px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #64b5f6 0%, #1581c6 100%);
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 32px;
}

.login-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(100, 181, 246, 0.4);
  background: linear-gradient(135deg, #1581c6 0%, #0d47a1 100%);
}

.login-button:active {
  transform: translateY(-1px);
}

.button-icon {
  font-size: 18px;
}

/* 注册区域 */
.register-section {
  text-align: center;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

.register-text {
  margin-right: 8px;
}

.register-link {
  color: #64b5f6;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
}

.register-link:hover {
  color: #1581c6;
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .login-main {
    gap: 30px;
    padding: 40px 20px;
  }

  .brand-slogan {
    font-size: 32px;
  }

  .form-features-container {
    gap: 30px;
    max-width: 1000px;
  }

  .features-sidebar {
    flex: 1;
    gap: 20px;
  }

  .feature-item {
    min-height: 170px;
  }

  .login-card {
    flex: 1;
  }
}

@media (max-width: 992px) {
  .form-features-container {
    flex-direction: column;
    gap: 30px;
    align-items: center;
  }

  .features-sidebar {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    max-width: 600px;
    flex-wrap: wrap;
    justify-content: center;
    flex: 1;
  }

  .feature-item {
    min-height: 180px;
    flex: 1;
    min-width: 220px;
  }

  .login-card {
    max-width: 500px;
    width: 100%;
  }
}

@media (max-width: 768px) {
  .login-container {
    padding: 0;
  }

  .login-main {
    padding: 40px 15px;
    gap: 30px;
  }

  .brand-slogan {
    font-size: 28px;
  }

  /* 在移动端隐藏特性侧边栏，只显示表单 */
  .features-sidebar {
    display: none;
  }

  .feature-item {
    padding: 20px;
  }

  .feature-icon {
    font-size: 28px;
    padding: 14px;
  }

  .feature-title {
    font-size: 16px;
  }

  .feature-desc {
    font-size: 13px;
  }

  .login-card {
    padding: 40px 30px;
    margin: 0 10px;
    max-width: 500px;
    width: calc(100% - 20px);
  }

  .login-title {
    font-size: 24px;
  }

  .login-subtitle {
    font-size: 14px;
  }

  .custom-input {
    height: 52px;
    font-size: 14px;
  }

  .login-button {
    height: 52px;
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .login-main {
    padding: 30px 10px;
    gap: 25px;
  }

  .brand-logo img {
    height: 50px;
  }

  .brand-slogan {
    font-size: 24px;
  }

  .features-section {
    margin-top: 10px;
  }

  .feature-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .login-card {
    padding: 35px 20px;
    margin: 0 5px;
    width: calc(100% - 10px);
  }

  .login-options {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .background-decoration {
    display: none;
  }
}
</style>